import React from 'react';
const RANGES = [{
  emoji: '👶',
  label: 'Niños de 4 a 11 años'
}, {
  emoji: '🧑',
  label: 'Adolescentes de 12 a 18 años'
}, {
  emoji: '👨',
  label: 'Adultos de 18 en adelante'
}];
export function Solution() {
  return <section className="flex flex-col gap-6 py-8" data-id="element-125">
      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A] text-center" data-id="element-126">
        Qué es el Sistema Integral
      </h3>

      <div className="flex flex-col bg-[#0F4C3A] text-white p-8 rounded-2xl shadow-xl border border-[#1B5E4F] gap-8" data-id="element-127">
        <p className="text-center text-xl md:text-2xl font-bold text-[#FBF8F3] font-serif" data-id="element-128">
          6 módulos clínicos · 540 fichas · 3 rangos etarios · Todo en un solo
          sistema
        </p>

        <p className="text-center text-[#FBF8F3]/90 text-lg" data-id="element-129">
          Cada módulo tiene 90 fichas divididas en 3 versiones por edad:
        </p>

        <div className="flex flex-col gap-3" data-id="element-130">
          {RANGES.map((r, idx) => <div key={idx} className="flex flex-col items-center gap-2 bg-white/10 rounded-xl py-5 px-4" data-id="element-131">
              <span className="text-4xl" data-id="element-132">{r.emoji}</span>
              <p className="font-bold text-[#FBF8F3] text-lg" data-id="element-133">{r.label}</p>
            </div>)}
        </div>

        <p className="text-center text-[#FBF8F3]/90 text-lg pt-2 border-t border-white/10" data-id="element-134">
          Cada ficha tiene instrucciones para el profesional, consigna para el
          paciente y espacio de registro clínico.
        </p>
      </div>
    </section>;
}